/**
 * Created by Languagenut on 25/07/2019.
 */



import React  from 'react';
import {Form , Row , Col} from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import LessonPlanService from '../services/lessonplan-services.js';
import LessonPlanStore from '../store/lessonplan-store.js';
import Translation from '../store/internationalization-store.js';
import LanguagenutPackage from '../classes/package.js';


export default class SongsStories  extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state ={
            selectedLanguage:'en'
        }
    }

    handelFilter(event){
        this.setState({selectedLanguage:event.currentTarget.value})
    }

    componentDidMount() {
        LessonPlanService.getAll()
    }

    componentWillMount(){
        LessonPlanStore.on("CHANGE" , () => {
            this.setState({
                plans:LessonPlanStore.getPlans(),
                allPlans:LessonPlanStore.getPlans()
            });
        });
    }

    getData(){
        var plans = this.state.plans || [];
        var filtered = [];

        for(var idx = 0 ; idx < plans.length ; idx++)
        {

            if(this.state.selectedLanguage == plans[idx].target_ietf)
            {
                filtered.push(plans[idx])
            }

        }

        return filtered
    }

    render(){



        const columns = [
            {
                dataField: 'title_translation_uid',
                text: Translation.get(2404 , 'text'),
                sort: true,
                headerClasses:"hide",
                style: ()=>{
                    return {width:'300px'}
                },
                align: "left",
                formatter: (cell)=>{
                    return Translation.get(cell , cell)
                }
            },
            {
                dataField: 'summary_translation_uid',
                text: Translation.get(2203 , 'Description'),
                headerClasses:"hide",
                sort: true,
                align: "left",
                formatter: (cell)=>{
                    return Translation.get(cell , cell)
                }
            },
            {
                dataField: 'download_path',
                text: Translation.get(2203 , 'Description'),
                headerClasses:"hide",
                sort: true,
                align: "left",
                formatter: (cell)=>{
                    return  <a href={"https://storage.languagenut.com"+cell} target="_blank" className="palette-Branding secondary bg btn btn-block waves-effect" role="button">
                        <span className="palette-White text">{Translation.get(826 , 'Download')}</span>
                    </a>
                }
            }
        ];

        const options = {
            // pageStartIndex: 0,
            sizePerPage: 15,
            hideSizePerPage: true,
            hidePageListOnlyOnePage: true
        };

        const selectOptions = [{ value: 'en' , label:'English'} , { value: 'es', label:'Spanish'} , { value: 'fr', label:'French'} , { value: 'de', label: 'German'}]
        var groups = <Form.Group style={{width:"300px" , height:"30px"}} controlId="exampleForm.ControlSelect1">
                <Form.Control onChange={this.handelFilter.bind(this)} as="select">
                    <option value={'en'}>{Translation.get(45 , 'English')}</option>
                    <option value={'fr'}>{Translation.get(46 , 'French')}</option>
                    <option value={'es'}>{Translation.get(47 , 'Spanish')}</option>
                    <option value={'de'}>{Translation.get(48 , 'German')}</option>
                </Form.Control>
            </Form.Group>
        
        if((new LanguagenutPackage()).isNewcomer()) {
            groups = <Form.Group style={{width:"300px" , height:"30px"}} controlId="exampleForm.ControlSelect1">
                <Form.Control onChange={this.handelFilter.bind(this)} as="select">
                    <option value={'en'}>{Translation.get(45 , 'English')}</option>
                </Form.Control>
            </Form.Group>
        }


        return <div>

            <Row className="align-items-center">
                <Col  md={3}>
                    <div class="d-flex align-items-left">
                        <div class="p-2 report_title">
                            {Translation.get(12737 , 'Lessons')}
                        </div>
                    </div>
                </Col>
                <Col md={9}>
                    <div class="d-flex flex-row-reverse">
                        <div class="p-2" >
                            {groups}
                        </div>
                    </div>
                </Col>

            </Row>
            <hr style={{marginBottom:".5rem"}}/>
            <BootstrapTable pagination={ paginationFactory(options) } stripped   bordered={ true } keyField='id' data={ this.getData() } columns={ columns } />
        </div>
    }

}